// sticky menu
var mainNav = document.getElementById('main-nav');
var mainNavSticky = document.getElementById('main-nav-sticky-version');
var topMenu = document.getElementById('top-menu');

window.onscroll = function() {
    if (window.pageYOffset > mainNav.offsetTop) {
        mainNavSticky.classList.add('sticky');
        mainNavSticky.classList.remove('hidden');
        mainNav.style.opacity = '0';
    } else {
        mainNavSticky.classList.remove('sticky');
        mainNavSticky.classList.add('hidden');
        mainNav.style.opacity = '100';
    }

    if (window.innerWidth < 1024 && window.pageYOffset > topMenu.offsetTop) {
        topMenu.classList.add('sticky');
    } else {
        topMenu.classList.remove('sticky');
    }
};
